var map = {
	"./ai/logoPagePhone.png": 464,
	"./computernaya-gramotnost/logoPagePhone.png": 465,
	"./ege-informatika/logoPagePhone.png": 466,
	"./frontend/logoPagePhone.png": 467,
	"./game-design/logoPagePhone.png": 468,
	"./graphic-design-pro/logoPagePhone.png": 469,
	"./graphic-design/logoPagePhone.png": 470,
	"./intensive/logoPagePhone.png": 471,
	"./osnovy-programmirovaniya/logoPagePhone.png": 472,
	"./predprinimatelstvo/logoPagePhone.png": 473,
	"./python/logoPagePhone.png": 474,
	"./scratch/logoPagePhone.png": 475,
	"./unity/logoPagePhone.png": 476,
	"./videoblogging/logoPagePhone.png": 477,
	"./web-razrabotka/logoPagePhone.png": 478
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 824;